/**
 * Configuration for API Server Details
 * Contains the base URL for all backend API calls
 * The URL is read from environment variables for flexibility across environments
 */

/** 
 * API Server Base URL
 * Retrieved from REACT_APP_API_URL environment variable
 * This URL is used as the base for all API endpoint calls throughout the application
 * 
 * Alternative configurations (commented out for reference):
 * - "http://127.0.0.1:5000/" - Local development server
 * - "http://20.15.166.198:5000/" - Azure/remote development server
 */
export const API_SERVER_URL = process.env.REACT_APP_API_URL
//export const API_SERVER_URL = "http://127.0.0.1:5000/"
//export const API_SERVER_URL = process.env.REACT_APP_API_URL
// export const API_SERVER_URL = "http://20.15.166.198:5000/"
//export const API_SERVER_URL = "http://20.15.166.198:5000/"
